<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid text-center" style="background-color: white;">
            <br>
            <div class="col-sm-12 col-xs-12 text-center">
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ชื่อ
                    </label>
                    <div class="col-sm-4">
                        <input class="form-control"
                               placeholder="ชื่อ"
                               v-model="form.first_name"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        นามสกุล
                    </label>
                    <div class="col-sm-4">
                        <input class="form-control"
                               placeholder="นามสกุล"
                               v-model="form.last_name"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        บริษัท
                    </label>
                    <div class="col-sm-4">
                        <input class="form-control"
                               placeholder="บริษัท"
                               v-model="form.company"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ที่อยู่
                    </label>
                    <div class="col-sm-4">
                        <input class="form-control"
                               placeholder="ที่อยู่"
                               v-model="form.address"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        เลขประจำตัวผู้เสียภาษี
                    </label>
                    <div class="col-sm-4">
                        <input class="form-control"
                               placeholder="เลขประจำตัวผู้เสียภาษี"
                               v-model="form.tax_number"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        เบอร์โทรศัพท์
                    </label>
                    <div class="col-sm-4">
                        <masked-input v-model="form.phone"
                                      mask="111-111-1111"
                                      placeholder="เบอร์โทรศัพท์"
                                      class="form-control"
                                      type="tel"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        อีเมล
                    </label>
                    <div class="col-sm-4">
                        <input class="form-control"
                               placeholder="อีเมล"
                               v-model="form.email"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        หมายเหตุ
                    </label>
                    <div class="col-sm-4">
                        <input class="form-control"
                               placeholder="หมายเหตุ"
                               v-model="form.remark"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        คำอธิบาย
                    </label>
                    <div class="col-sm-4">
                        <input class="form-control"
                               placeholder="คำอธิบาย"
                               v-model="form.description"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ใบเสนอราคา 1
                    </label>
                    <div class="col-sm-4">
                        <b-form-file
                            ref="quotation_file"
                            @change="quotationFileUpload(1)"
                            placeholder="Choose a file...">
                        </b-form-file>
                    </div>
                    <div class="col-sm-4 text-left" v-if="form.quotation_file_1">
                        <a :href="form.quotation_file_1" target="_blank">
                            <icon name="file-alt" style="width: 25px"></icon>
                            ดูใบเสนอราคา 1
                        </a>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ใบเสนอราคา 2
                    </label>
                    <div class="col-sm-4">
                        <b-form-file
                            ref="quotation_file"
                            @change="quotationFileUpload(2)"
                            placeholder="Choose a file...">
                        </b-form-file>
                    </div>
                    <div class="col-sm-4 text-left" v-if="form.quotation_file_2">
                        <a :href="form.quotation_file_2" target="_blank">
                            <icon name="file-alt" style="width: 25px"></icon>
                            ดูใบเสนอราคา 2
                        </a>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ใบเสนอราคา 3
                    </label>
                    <div class="col-sm-4">
                        <b-form-file
                            ref="quotation_file"
                            @change="quotationFileUpload(3)"
                            placeholder="Choose a file...">
                        </b-form-file>
                    </div>
                    <div class="col-sm-4 text-left" v-if="form.quotation_file_3">
                        <a :href="form.quotation_file_2" target="_blank">
                            <icon name="file-alt" style="width: 25px"></icon>
                            ดูใบเสนอราคา 3
                        </a>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ใบเสนอราคา 4
                    </label>
                    <div class="col-sm-4">
                        <b-form-file
                            ref="quotation_file"
                            @change="quotationFileUpload(4)"
                            placeholder="Choose a file...">
                        </b-form-file>
                    </div>
                    <div class="col-sm-4 text-left" v-if="form.quotation_file_4">
                        <a :href="form.quotation_file_2" target="_blank">
                            <icon name="file-alt" style="width: 25px"></icon>
                            ดูใบเสนอราคา 4
                        </a>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ใบเสนอราคา 5
                    </label>
                    <div class="col-sm-4">
                        <b-form-file
                            ref="quotation_file"
                            @change="quotationFileUpload(5)"
                            placeholder="Choose a file...">
                        </b-form-file>
                    </div>
                    <div class="col-sm-4 text-left" v-if="form.quotation_file">
                        <a :href="form.quotation_file" target="_blank">
                            <icon name="file-alt" style="width: 25px"></icon>
                            ดูใบเสนอราคา 5
                        </a>
                    </div>
                </div>
                <br/>
                <div>
                    <button @click="saveVendorData"
                            type="button"
                            class="btn btn-success">
                        <icon name="save" style="width: 25px"></icon>
                        บันทึก
                    </button>
                    &nbsp&nbsp
                    <button @click="goToVendor"
                            type="button"
                            class="btn btn-outline-secondary">
                        <icon name="times" style="width: 25px"></icon>
                        ยกเลิก
                    </button>
                    &nbsp&nbsp
                    <button v-if="id" type="button"
                            class="btn btn-danger"
                            @click="showModalDelete(id)">
                        <icon name="trash"></icon>
                        ลบ
                    </button>
                </div>
            </div>
            <br/>
        </div>
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteData">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideModalDelete">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import HeaderTitle from "../../HeaderTitle";
import FormTextarea from "bootstrap-vue/es/components/form-textarea/form-textarea";
import MaskedInput from 'vue-masked-input'

export default {
    components: {
        FormTextarea,
        HeaderTitle,
        MaskedInput
    },
    name: "vendor-information",
    created() {
        if (!this.$route.query.id) {
            this.$store.dispatch('Vendor/clearFormData');
        } else {
            this.id = window.atob(this.$route.query.id);
            this.$store.dispatch('Vendor/show', this.id);
        }
    },
    computed: {
        ...mapState({
            form: state => {
                return state.Vendor.vendorForm
            }
        })
    },
    data() {
        return {
            items: [
                {
                    text: "รายการเจ้าหนี้",
                    to: {name: "vendor"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            id: '',
            placeholder: 'Choose a file...',
            placeholder_1: 'Choose a file...',
            placeholder_2: 'Choose a file...',
            placeholder_3: 'Choose a file...',
            placeholder_4: 'Choose a file...',
        };
    },
    methods: {
        //Modal
        showModalDelete(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        // CALL API
        saveVendorData() {
            this.id = this.id ? this.id : null;
            this.$store.dispatch('Vendor/save', this.id).then(() => {
                if (this.id == null) {
                    this.$router.back()
                } else {
                    window.close();
                }
            });
        },
        goToVendor() {
            this.id = this.id ? this.id : null;
            if (this.id == null) {
                this.$router.back()
            } else {
                window.close();
            }
        },
        quotationFileUpload(quotation_file_id) {
            let input = event.target;
            let file = input.files[0];
            let formData = new FormData();
            formData.append('file', file);
            this.$store.dispatch("Common/getPathFile", formData).then(path => {
                //console.log(path);
                if (quotation_file_id === 5) {
                    this.form.quotation_file = path;
                    if (this.form.quotation_file) {
                        this.placeholder = path;
                    }
                }
                if (quotation_file_id === 1) {
                    this.form.quotation_file_1 = path;
                }
                if (quotation_file_id === 2) {
                    this.form.quotation_file_2 = path;
                }
                if (quotation_file_id === 3) {
                    this.form.quotation_file_3 = path;
                }
                if (quotation_file_id === 4) {
                    this.form.quotation_file_4 = path;
                }
            });
        },
        deleteData() {
            this.$store.dispatch('Vendor/delete', this.id).then(() => {
                this.hideModalDelete();
                this.$store.dispatch('Vendor/setVendors');
                this.goToVendor();
            });
        },
    }
};
</script>

<style scoped></style>
